module.exports = __webpack_public_path__ + "main/images/shared/save-content.83d83d7d8f37e27ccc8007ca079b828e.png";